export interface PresetOption {
	label: string;
	value: string;
}

export const closestPresetValue = (
	options: PresetOption[],
	raw: string | number | undefined
): string => {
	const rawNumber = typeof raw === 'number' ? raw : Number.parseFloat(String(raw ?? ''));
	if (Number.isNaN(rawNumber)) {
		return options[0].value;
	}
	return options.reduce((closest, option) => {
		const distance = Math.abs(Number.parseFloat(option.value) - rawNumber);
		const closestDistance = Math.abs(Number.parseFloat(closest.value) - rawNumber);
		return distance < closestDistance ? option : closest;
	}, options[0]).value;
};

export const FONT_SIZE_VALUES = ['14px', '16px', '20px'] as const;
export const LINE_HEIGHT_VALUES = ['120%', '160%', '175%'] as const;
export const SPACING_VALUES = ['0px', '8px', '16px', '24px'] as const;
export const BORDER_WIDTH_VALUES = ['0px', '1px', '2px', '4px'] as const;
export const CORNER_RADIUS_VALUES = ['0px', '4px', '8px', '16px'] as const;
